import { render, staticRenderFns } from "./companycharitable.vue?vue&type=template&id=02bd0e8e&"
import script from "./companycharitable.vue?vue&type=script&lang=js&"
export * from "./companycharitable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports